module.exports = __webpack_public_path__ + "img/kuangjiao_yj_weizhaoqing.87ebe04d.jpg";